import { Component } from '@angular/core';
import { BREADCRUMB_TEXTS } from '../../constants/breadcrumb.constant';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  readonly texts = BREADCRUMB_TEXTS;
}
